<div [ngClass]="containerClassReturn(shortAssignableType)">
  @if (!loaded) {
    <section
      fxFlexFill
      fxLayoutAlign="center center"
      class="spinner-box"
      >
      <mat-spinner></mat-spinner>
    </section>
  }
  @if (loaded) {
    <div
      class="switch-main-div"
      [ngClass]="shortAssignableType"
      >
      <!-- Resource Activity Nothing to show? -->
      @if (asset?.assetTypeId === assetTypeIds.EREADER) {
        <div
          class="height-100perc width-100perc position-relative"
          >
          <iframe
            fxFlex="100"
            [src]="embedUrl"
            width="100%"
            onload="this.height=(window.innerHeight - 90);"
            frameborder="0"
            allowfullscreen
            allow="microphone *; camera *;"
            title="Resource Activity iframe"
          ></iframe>
        </div>
      }
      <!-- PERFORM ASSIGNMENT -->
      @if (asset?.assetTypeId === assetTypeIds.PERFORM) {
        <div>
          <section fxFlexFill fxLayoutAlign="center center" fxLayout="column">
            <avenue-eval-student-video [assignment]="assignment">
            </avenue-eval-student-video>
            <avenue-eval
              class="performPadding"
              [assignment]="assignment"
              [userProfile]="userProfile"
              [isWorldLanguageProgram]="isWorldLanguageProgram"
            ></avenue-eval>
          </section>
        </div>
      }
      <!-- DISCOVER ASSIGNMENT -->
      @if (asset?.assetTypeId === assetTypeIds.EBOOK_ACT) {
        <div>
          <section class="spine-activity-submission">
            <section-label
              class="section-label"
              [sectionLabelContent]="attemptsSectionLabel"
            ></section-label>
            @if (
              (loadTable || displayIFrame) &&
              !autoEvaluatedWithoutScore
              ) {
              <p
                class="data-value font-size-14px attempts-description"
                >
                Valid attempts are shaded and selected score is in bold.
                Click row to view selected attempt.
              </p>
            }
            @if (loadTable && !displayIFrame) {
              <mat-table
                [dataSource]="dataSource"
                class="attempts-table"
                >
                <!--attempt number-->
                <ng-container matColumnDef="attemptNumber">
                  <mat-header-cell *matHeaderCellDef>
                    No.</mat-header-cell
                    >
                    <mat-cell *matCellDef="let attempt">
                      {{ attempt.attempt }}
                    </mat-cell>
                  </ng-container>
                  <!--submitted date-->
                  <ng-container matColumnDef="submitted">
                    <mat-header-cell *matHeaderCellDef>
                      Submitted</mat-header-cell
                      >
                      <mat-cell *matCellDef="let attempt; let i = index">
                        <section
                          innerHTML="{{ getDate(attempt.completed) }}"
                        ></section>
                        <!-- If attempt is practice, show label -->
                        @if (
                          assignment?.maxAttempts !== -1 &&
                          assignment?.maxAttempts &&
                          i + 1 > assignment?.maxAttempts
                          ) {
                          <span
                            class="practice-attempt-span"
                            >
                            (Practice Attempt)</span
                            >
                          }
                        </mat-cell>
                      </ng-container>
                      <!--score-->
                      <ng-container matColumnDef="score">
                        <mat-header-cell *matHeaderCellDef>
                          Score</mat-header-cell
                          >
                          <mat-cell
                            *matCellDef="let attempt"
                            [ngClass]="{
                                'select-bold': attempt.selected === 1
                            }"
                            >
                            {{ attempt.value }}/{{ scorePossible }}
                          </mat-cell>
                        </ng-container>
                        <!--header row-->
                        <mat-header-row
                          *matHeaderRowDef="displayedColumns"
                        ></mat-header-row>
                        <mat-row
                          class="clickable-row"
                        [ngClass]="{
                            'shaded-background': row.attemptID != null
                        }"
                          *matRowDef="let row; columns: displayedColumns"
                          (click)="generateIFrameURL(row)"
                          >
                        </mat-row>
                      </mat-table>
                    }
                    @if (!loadTable && !autoEvaluatedWithoutScore) {
                      <div
                        class="no-response"
                        >
                        <mat-icon>info</mat-icon>
                        This student has not made an attempt.
                      </div>
                    }
                    @if (autoEvaluatedWithoutScore) {
                      <p
                        class="autoEvaluatedWithoutScore"
                        >
                        <mat-icon>warning</mat-icon>This student has completed this
                        assignment and we have stored it. We are working on
                        retrieving the score and will display it here as soon as we
                        can.
                      </p>
                    }
                  </section>
                  <!--attempt iframe-->
                  @if (displayIFrame) {
                    <section
                      fxFlexFill
                      fxLayout="column"
                      fxLayoutAlign="center"
                      class="attempt-iframe-outer"
                      >
                      <!--view grade attempt via iFrame-->
                      <div class="attempt-iframe-wrapper">
                        <iframe
                          id="attempt-frame"
                          class="attempt-frame"
                          [src]="iframeURL"
                          allow="microphone *; camera *;"
                          fxFlex.gt-md="attempt-frame-gt-md"
                          frameborder="0"
                          webkitallowfullscreen
                          mozallowfullscreen
                          allowfullscreen
                          title="View Grade Attempt iframe"
                        ></iframe>
                      </div>
                      <div class="attempt-list-button">
                        <button
                          mat-raised-button
                          color="primary"
                          (click)="closeIFrame()"
                          >
                          <mat-icon class="margin-top-neg-4px"
                            >chevron_left</mat-icon
                            >
                            Attempts List
                          </button>
                          <p>View selected attempt and scroll if needed.</p>
                        </div>
                      </section>
                    }
                  </div>
                }
                <!-- JOURNAL/CUSTOM ASSIGNMENT -->
                @if (asset?.assetTypeId === assetTypeIds.CUSTOM_ACT) {
                  <div
                    class="journal-container"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    >
                    <stimulus-activity
                      class="submission"
                      [stimulus]="asset"
                      [moduleID]="assignment?.assetId"
                    ></stimulus-activity>
                    @if (assignment?.completedAt || hasSubmission(assignment)) {
                      <div
                        fxLayout="column"
                        fxLayoutAlign="center start"
                        fxFill
                        fxFlex="100"
                        class="submission-container"
                        >
                        @if (
                          (hasTextResponse === true && responseType === 'both') ||
                          responseType === 'text'
                          ) {
                          <div
                            class="submission"
                            fxLayout="column"
                            fxLayoutAlign="center start"
                            fxFill
                            fxFlex="100"
                            >
                            <div><b>Submitted Text</b></div>
                            <div
                              class="submitted-text"
                              [innerHTML]="assignment?.submissionText"
                            ></div>
                          </div>
                        }
                        @if (
                          (hasFileResponse && responseType === 'both') ||
                          responseType === 'file'
                          ) {
                          <div
                            class="submission"
                            fxLayout="column"
                            fxLayoutAlign="center start"
                            fxFill
                            fxFlex="100"
                            >
                            @if (hasSubmissionUrl()) {
                              <div class="padding-bottom-15px">
                                The student has submitted a URL:
                                <span class="font-weight-bold">{{
                                  this.assignment?.submissionUrl
                                }}</span>
                              </div>
                            }
                            @if (hasSubmissionFile()) {
                              <div
                                class="padding-bottom-15px"
                                >
                                The student has uploaded a file
                              </div>
                            }
                            @if (!hasSubmissionUrl() && !hasSubmissionFile()) {
                              <div
                                class="padding-bottom-15px"
                                >
                                Student submission could not be found.
                              </div>
                            }
                            <div class="submission__btns">
                              @if (hasSubmissionUrl()) {
                                <button
                                  mat-raised-button
                                  color="primary"
                                  (click)="openSubmission('URL')"
                                  >
                                  View URL Submission
                                </button>
                              }
                              @if (hasSubmissionFile()) {
                                <button
                                  mat-raised-button
                                  color="primary"
                                  (click)="openSubmission('FILE')"
                                  >
                                  View File Submission
                                </button>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (!assignment?.completedAt && !hasSubmission(assignment)) {
                      <div
                        class="no-response"
                        >
                        <mat-icon>info</mat-icon>
                        This student has not submitted any work.
                      </div>
                    }
                  </div>
                }
                <!-- DEVSPACE ASSIGNMENT -->
                @if (asset?.assetActivityTypeId === assetActivityTypeIds.DEVSPACE) {
                  <div
                    class="height-100perc width-100perc position-relative"
                    >
                    <devspace-iframe [fidoUser]="fidoUserData"> </devspace-iframe>
                  </div>
                }
                @if (
                  asset?.assetActivityTypeId === assetActivityTypeIds.MAKEQUEST
                  ) {
                  <iframe
                    width="100%"
                    style="height: 100vh"
                    [src]="iframeURL"
                    frameborder="0"
                    allow="microphone *; camera *;"
                    title="Make Quest iframe"
                    >
                  </iframe>
                }
                <!-- LTI iFrame -->
                @if (
                  shortAssignableType === assetTypeIds.READYCHECK &&
                  (this.userProfile?.roleLevel === 5 || hasSubmission(assignment))
                  ) {
                  <div
                    class="readyCzechEvalHousing"
                    >
                    <lti-iframe
                      [user]="userProfile"
                      [student]="student"
                      [assignment]="assignment"
                      [course]="course"
                      [launchType]="'edulastic-ready-check'"
                      [destination]="readyCheckDestination"
                      >
                    </lti-iframe>
                  </div>
                }
                <!-- LTI C2C iFrame -->
                @if (shortAssignableType === assetTypeIds.C2C) {
                  <div
                    class="readyCzechEvalHousing"
                    >
                    <lti-iframe
                      [launchType]="'c2c'"
                      [user]="userProfile"
                      [assignment]="assignment"
                      [course]="course"
                      [readOnly]="true"
                      >
                    </lti-iframe>
                  </div>
                }
              </div>
            }
          </div>
